import React from 'react';
import { T } from '@colonist/ui';
import styles from './UsernameChangeStatusNote.module.scss';
import { clamp } from '@colonist/utils';
/* Status note shown above the username input */ export const UsernameChangeStatusNote = ({ changeScenario: scenario, freeChangesLeft, colonistCoins, price })=>{
    if (scenario == 'login') {
        return /*#__PURE__*/ React.createElement("p", {
            className: styles.statusNote
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:homePage.header.changeUsername.login'
            }
        }));
    }
    if (scenario == 'notEnoughCoins') {
        const coinsNeeded = clamp(price - colonistCoins, 0, Number.POSITIVE_INFINITY);
        return /*#__PURE__*/ React.createElement("p", {
            className: styles.statusNote
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:homePage.header.changeUsername.notEnoughCoins.body',
                options: {
                    coinsNeeded: coinsNeeded
                }
            }
        }));
    }
    if (scenario == 'coins') {
        return /*#__PURE__*/ React.createElement("p", {
            className: styles.statusNote
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:homePage.header.changeUsername.coinsBalanceNote',
                options: {
                    colonistCoins: colonistCoins,
                    price: price
                }
            }
        }));
    }
    if (freeChangesLeft <= 0) return null;
    return /*#__PURE__*/ React.createElement("p", {
        className: styles.statusNote
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.changeUsername.freeChangesLeftNote',
            options: {
                count: freeChangesLeft
            }
        }
    }));
};
